import { useState, useEffect, useRef, useCallback } from 'react'
import useThrottledOnScroll from './useThrottledOnScroll'

const useScrollSpy = ({ items = [], target = window } = {}) => {
  const itemsWithNodeRef = useRef([])
  useEffect(() => {
    itemsWithNodeRef.current = getItemsClient(items)
  }, [items])

  const [activeState, setActiveState] = useState(null)

  const findActiveIndex = useCallback(() => {
    let active
    for (let i = itemsWithNodeRef.current.length - 1; i >= 0; i -= 1) {
      if (document.getElementById('scrollspy').scrollTop < 50) {
        active = { hash: null }
        break
      }
      const item = itemsWithNodeRef.current[i]
      if (
        (item.node &&
          item.node.offsetTop <
          document.getElementById('scrollspy').getBoundingClientRect().top +
          document.getElementById('scrollspy').scrollTop +
          document.getElementById('scrollspy').clientHeight / 8)
      ) {
        active = item
        break
      }
    }

    if (active && activeState !== active.hash) {
      setActiveState(active.hash)
    }
  }, [activeState])

  useThrottledOnScroll(items.length > 0 ? findActiveIndex : null, 100)

  return activeState
}

const getItemsClient = items =>
  items.map(({ hash }) => ({ hash, node: document.getElementById(hash) }))

export default useScrollSpy